import React from 'react';

export type ChildKeyToDomRect = Record<string | symbol | number, DOMRect>;

const calculateBoundingBoxes = (children): ChildKeyToDomRect => {
	const boundingBoxes = {};

	React.Children.forEach(children, child => {
		if (!child.ref?.current) {
			return;
		}
		const domNode: HTMLElement = child.ref.current;
		const nodeBoundingBox = domNode.getBoundingClientRect();

		if (!nodeBoundingBox) {
			return;
		}

		boundingBoxes[child.key] = nodeBoundingBox;
	});

	return boundingBoxes;
};

export default calculateBoundingBoxes;
